import React, { Component } from "react";
// import { Typography, Step, StepContent, StepLabel, Stepper } from '@mui/material';

import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Stepper, Step, StepContent, Typography } from "@mui/material";

import StepLabel from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import moment from "moment";
import "./styles/style.scss";
import { withNamespaces } from "react-i18next";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#707789",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#707789",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 1,
    borderRadius: 1,
  },
}));
class StepperEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      steps: props.steps ? props.steps : [],
      isVertical: props.vertical ? props.vertical : false,
      pushDiv: false,
    };
  }

  componentDidMount() {
    this.addMiddleStepper();
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      steps: nextProps.steps ? nextProps.steps : [],
    });
  };

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
    window.addEventListener("resize", this.addMiddleStepper);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
    window.addEventListener("resize", this.addMiddleStepper);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  addMiddleStepper = () => {
    const { isVertical, steps, width } = this.state;
    const isMobile = isVertical ? isVertical : width <= 900;
    steps.map((e, i) => {
      if (i !== 0 && e.middleStep) {
        let circleId = `circle${e.idStep}`;
        let findCircle = document.getElementById(circleId);
        if (findCircle) {
          findCircle.remove();
        }
        let findStep = document.getElementById(e.idStep);
        if (findStep) {
          var divPush = document.createElement("div");
          divPush.setAttribute("id", circleId);
          var className = "tooltipNew topNew";
          if (isMobile) {
            className = "tooltipNewVert leftVert";
          }
          divPush.setAttribute("class", className);
          var circle = `<svg key="svg-circle-${i}" class="MuiSvgIcon-root MuiStepIcon-root circleMiddle" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><circle cx="12" cy="12" r="12"></circle></svg><span class="${isMobile ? "tiptextVert" : "tiptext"
            }">${e.middleStep}</span>`;
          divPush.innerHTML = circle;
          findStep.parentNode.insertBefore(divPush, findStep);
        }
      }
      return e;
    });
  };

  render() {
    const { steps, width, isVertical } = this.state;
    const isMobile = isVertical ? isVertical : width <= 1000;

    return (
      <div style={{ paddingTop: "3%", paddingBottom: "3%" }}>
        <Stepper
          key={0}
          className={isMobile ? "" : "disabledBorderLeft"}
          orientation={isMobile ? "vertical" : "horizontal"}
          style={{ width: "100%", alignContent: "center", flexWrap: "wrap" }}
          alternativeLabel={isMobile ? false : true}
          nonLinear={isMobile ? false : true}
          connector={<QontoConnector />}
        >
          {steps.map((step, index) => {
            return (
              <Step
                id={step.idStep}
                // connectorColor="red"
                active={true}
                key={`${this.props.t(step.label)}-${index}-step`}
                className={
                  step.middle
                    ? "circleGreen"
                    : step.completed
                      ? "completedStep"
                      : "disabledCircle"
                }
                completed={step.completed}
              >
                <StepLabel>
                  <span className="statusCardInfo">
                    {" "}
                    {this.props.t(step.label)}
                  </span>
                </StepLabel>
                <StepContent className="verticalColorStep">
                  <Typography className='stepper-value'>
                    {step.value ? step.value : `${"\u00A0"}`}
                  </Typography>
                </StepContent>
              </Step>
            );
          })}
        </Stepper>
      </div>
    );
  }
}

export default withNamespaces()(StepperEvent);
